import React from 'react'

export const IdentityConsent = () => {
  return (
    <div>
      <p>
        Select an option for HHS-OIG to disclose your identity in the course of
        its investigation.
      </p>
      <a
        href="https://oig.hhs.gov/fraud/report-fraud/identity.asp"
        target="_blank"
        rel="noopener noreferrer"
      >
        Read more about your options for self-disclosure
      </a>
    </div>
  )
}
